import { useState, useEffect, useMemo, useCallback } from 'react';
import debounce from 'lodash/debounce';
const useFirstVisibleNode = (nodeIds, config) => {
  const [visibleNodeId, setVisibleNodeId] = useState(null);
  const {
    debounceMs = 25
  } = config || {};

  // get headlines nodes - Should only be recalculated when the ids change
  const nodes = useMemo(() => {
    if (nodeIds?.length > 0) {
      return Array.from(document.querySelectorAll(nodeIds.join(',')));
    }
    return [];
  }, [nodeIds]);
  const getVisibleNodeId = useCallback(debounce(() => {
    // Get the top postion of each headline node relative to the viewport
    const topOffsets = nodes.map(node => node.getBoundingClientRect().top);

    // Get the node closer to zero (the top of the viewport)
    // We have the default offset as Infinity so it's always greater that the first node Y position
    const visibleNode = topOffsets.reduce((prev, currentOffset, currentIndex) => {
      const node = Math.abs(currentOffset - 0) < Math.abs(prev.offset - 0) ? {
        node: nodes[currentIndex],
        offset: currentOffset
      } : prev;
      return node;
    }, {
      node: nodes[0],
      offset: Infinity
    });

    // Set the visible node id
    setVisibleNodeId(`#${visibleNode?.node?.id}`);
  }, debounceMs), [nodes]);

  // Recalculate the visible node id when the page is scrolled
  useEffect(() => {
    window.addEventListener('scroll', getVisibleNodeId);
    return () => {
      window.removeEventListener('scroll', getVisibleNodeId);
    };
  }, [getVisibleNodeId]);

  // Recalculate the visible node id when the page is resized
  useEffect(() => {
    window.addEventListener('resize', getVisibleNodeId);
    return () => {
      window.removeEventListener('resize', getVisibleNodeId);
    };
  }, [getVisibleNodeId]);
  return visibleNodeId;
};
export default useFirstVisibleNode;